import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class TranslocoTitleStrategy extends TitleStrategy {
    private readonly title = inject(Title);
    private readonly transloco = inject(TranslocoService);

    override updateTitle(snapshot: RouterStateSnapshot): void {
        const routeTitle = this.buildTitle(snapshot);
        if (!routeTitle) {
            return;
        }
        const translated = this.transloco.translate(routeTitle);
        this.title.setTitle(translated ?? this.humanize(routeTitle));
    }
    
    private humanize(key: string): string {
        const segment = key.split('.')[0];
        return segment.replace(/[-_]/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    }
}